{
  "toasts": {
    "created": "¡Webhook creado correctamente!",
    "createError": "Error al crear el webhook",
    "updated": "¡Webhook actualizado correctamente!",
    "updateError": "Error al actualizar el webhook",
    "deleted": "¡Webhook eliminado correctamente!",
    "deleteError": "Error al eliminar el webhook",
    "testSent": "¡Webhook de prueba enviado!",
    "testError": "Error al enviar el webhook de prueba"
  },
  "webhooks": {
    "events": {
      "userCreated": "Miembro creado",
      "userUpdated": "Miembro modificado",
      "enrollmentCreated": "Inscripción creada",
      "enrollmentRemoved": "Inscripción eliminada",
      "lessonCompleted": "Lección completada",
      "courseCompleted": "Curso completado",
      "paymentApproved": "Pago aprobado",
      "paymentRefunded": "Pago reembolsado"
    },
    "validation": {
      "nameRequired": "Indica el nombre del webhook",
      "urlRequired": "Indica la URL del webhook",
      "eventsRequired": "Selecciona al menos un evento"
    },
    "secretCopied": "Secret copiado al portapapeles",
    "subtitle": "Gestiona webhooks para integrarte con sistemas externos",
    "new": "Nuevo webhook",
    "active": "Activo",
    "inactive": "Inactivo",
    "eventCount_one": "{{count}} evento",
    "eventCount_zero": "{{count}} eventos",
    "eventCount_other": "{{count}} eventos",
    "actions": {
      "viewLogs": "Ver logs",
      "sendTest": "Enviar prueba",
      "copySecret": "Copiar secret",
      "edit": "Editar",
      "delete": "Eliminar",
      "cancel": "Cancelar",
      "save": "Guardar",
      "create": "Crear"
    },
    "empty": {
      "title": "No hay ningún webhook registrado",
      "description": "Crea tu primer webhook para integrarte con sistemas externos"
    },
    "form": {
      "editTitle": "Editar webhook",
      "editDescription": "Actualiza la configuración del webhook.",
      "createDescription": "Configura un nuevo webhook para recibir notificaciones de eventos.",
      "name": "Nombre",
      "namePlaceholder": "P. ej.: Notificación de Zapier",
      "urlPlaceholder": "https://ejemplo.com/webhook",
      "events": "Eventos",
      "activeHint": "Si está desactivado, no se realizará ninguna entrega"
    },
    "delete": {
      "title": "Eliminar webhook",
      "description": "¿Seguro que quieres eliminar el webhook <bold>{{name}}</bold>? Esta acción no se puede deshacer y se eliminarán todos los logs de entrega."
    },
    "logs": {
      "title": "Logs - {{name}}",
      "description": "Entregas recientes de este webhook",
      "event": "Evento",
      "status": "Estado",
      "code": "Código",
      "date": "Fecha",
      "ok": "OK",
      "failed": "Fallo",
      "pagination_one": "Página {{page}} de {{totalPages}} ({{count}} registro)",
      "pagination_zero": "Página {{page}} de {{totalPages}} ({{count}} registros)",
      "pagination_other": "Página {{page}} de {{totalPages}} ({{count}} registros)",
      "previous": "Anterior",
      "next": "Siguiente",
      "empty": "No se encontraron logs para este webhook"
    }
  }
}
